import { z } from 'zod'
import {
  CitySchema,
  EmailSchema,
  NameSchema,
  PhoneSchema,
  PostalCodeSchema,
  ProvinceSchema,
} from '@/schemas'
import { StreetSchema } from '@/schemas/streetSchema'

const FamilyRelationEnum = z.enum([
  'FATHER',
  'MOTHER',
  'SON',
  'DAUGHTER',
  'SPOUSE',
  'BROTHER',
  'SISTER',
  'GUARDIAN',
  'OTHER',
])
export const MemberCreateSchema = z.object({
  name: NameSchema,
  address: z.object({
    street: StreetSchema,
    city: CitySchema,
    province: ProvinceSchema,
    postal: PostalCodeSchema,
  }),
  phone: PhoneSchema.optional(),
  email: EmailSchema.optional(),
  etransferEmail: EmailSchema.optional().nullable(),
  noEmail: z.boolean(),
  churchId: z.string(),
  role: z.enum(['PASTOR', 'DEACON', 'ANNOITED', 'MEMBER']),
  familyMembers: z
    .array(
      z.object({
        memberId: z.string(),
        relation: FamilyRelationEnum,
      }),
    )
    .optional(),
})
export const MemberUpdateSchema = MemberCreateSchema.extend({
  _id: z.string(),
  active: z.boolean(),
})
export const MemberSchema = MemberUpdateSchema.extend({
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
})
export type MemberCreateData = z.infer<typeof MemberCreateSchema>
export type MemberUpdateData = z.infer<typeof MemberUpdateSchema>
export type MemberData = z.infer<typeof MemberSchema>
